<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NUMywx/tc-custom/9781477321591.jpg?1705006395766" alt="This image is the cover for the book LEGO Movie, 21st Century Film Essentials"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">LEGO Movie, 21st Century Film Essentials
      </h1>
      <p class="bookDescription body article font2">
        <p> What happens when we set out to understand LEGO not just as a physical object but as an idea, an icon of modernity, an image—maybe even a moving image? To what extent can the LEGO brick fit into the multimedia landscape of popular culture, especially film culture, today? Launching from these questions, Dana Polan traces LEGO from thing to film and asserts that <i>The LEGO Movie</i> is an exemplar of key directions in mainstream cinema, combining the visceral impact of effects and spectacle with ironic self-awareness and savvy critique of mass culture as it reaches for new heights of creativity. </p><p> Incorporating insights from conversations with producer Dan Lin and writer-directors Phil Lord and Chris Miller, Polan examines the production and reception of <i>The LEGO Movie</i> and closely analyzes the film within popular culture at large and in relation to LEGO as a toy and commodity. He identifies the film’s particular stylistic and narrative qualities, its grasp of and response to the culture industry, and what makes it a distinctive work of animation within the seeming omnipresence of animation in Hollywood, and reveals why the blockbuster film, in all its silliness and seriousness, stands apart as a divergent cultural work. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dana Polan
      </h2>
      
      <p class="authorDescription body article"> Dana Polan is a professor of cinema studies in the Tisch School of the Arts at New York University and former president of the Society for Cinema Studies. He is the author of eight books in film and media studies, including The Sopranos and Pulp Fiction, and approximately two hundred essays and reviews. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Texas Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6e651939